import { useContext } from 'react';
import { OtnWidget } from '../../../editor/features/build/requestModels/widgets/OtnWidget';
import { PathGraphContext } from '../../widgets/common/PathGraph/PathGraph';
import { useCommonWidgetHandlers } from './use-common-widget-handlers';

export const useOtnWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();
  const { setActiveNode, addDialogueWidgetsToGraph } =
    useContext(PathGraphContext);

  const addNew = async (
    dialogueId: number,
    sortOrder: number,
    widgetPageId?: number,
  ) => {
    const newWidget = OtnWidget.make(dialogueId, sortOrder, widgetPageId);

    const createdWidget = await commonWidgetHandlers.create(
      newWidget,
      dialogueId,
      sortOrder,
    );

    if (createdWidget) {
      if (createdWidget.config.pageId) {
        addDialogueWidgetsToGraph?.([createdWidget]);
        setActiveNode?.({
          id: createdWidget.id,
          type: 'widget',
          dialogueId: createdWidget.config.pageId,
          action: 'open',
          getNextDialogue: true,
        });
      }
    }
    return createdWidget;
  };

  return {
    delete: commonWidgetHandlers.delete,
    update: commonWidgetHandlers.update,
    addNew,
  };
};
